import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MxSharedModule } from 'src/app/shared/mx.shared.module';
import { MxEnsureModuleLoadedOnceGuard } from '../../mx.ensure-module-loaded-once.guard';
import { BreadcrumbComponent } from './breadcrumb.component';
import { ConfigComponent } from './config.component';
import { FooterComponent } from './footer.component';
import { InlineMenuComponent } from './inlinemenu.component';
import { MainComponent } from './main.component';
import { MenuComponent } from './menu.component';
import { MenuitemComponent } from './menuitem.component';
import { TopbarComponent } from './topbar.component';
import { SzSidebarComponent } from './sz-sidebar.component';
import { SzTopbarComponent } from './sz-topbar.component';
import { SzBottomNavComponent } from './sz-bottom-nav.component';

@NgModule({
  imports: [CommonModule, RouterModule, MxSharedModule],
  exports: [
    MainComponent,
  ],
  declarations: [
    MainComponent,
    BreadcrumbComponent,
    MenuComponent,
    MenuitemComponent,
    ConfigComponent,
    InlineMenuComponent,
    TopbarComponent,
    FooterComponent,
    SzSidebarComponent,
    SzTopbarComponent,
    SzBottomNavComponent,  ],
})
export class LayoutModule extends MxEnsureModuleLoadedOnceGuard {
  // Ensure that OverlayModule is only loaded into AppModule

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: LayoutModule) {
    super(parentModule, 'CoreModule');
  }
}
